export const getImportedPaymentList = (state) => state.importedPaymentList || [];
export const getPageTotal = (state) => {
	const { importedPaymentList } = state;
	return importedPaymentList.reduce((accumulator, data) => {
		const amount = Number(data.amount.replace(/,/g, ''));
		return accumulator + (Number.isNaN(amount) ? 0 : amount);
	}, 0);
};
